import { Button, Divider, Drawer, Typography } from "antd";
import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const MerchantReading = ({
  open,
  close,
  totalGross,
  totalDiscount,
  totalCostPerProd,
  totalDineIn,
  totalTakeOut,
  totalPickup,
  totalDelivery,
  totalCash,
  totalECash,
  //new
  totalGCash,
  totalGCredit,
  totalPaymaya,
  totalCreditCard,
  totalDebitCard,
  totalBankTransfer,
  totalCheque,
  //
  data,
  dateFrom,
  dateTo,
  perproductcost,
}) => {
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);

  // console.log("totalGross: ", totalGross);
  // console.log("totalDiscount: ", totalDiscount);
  // console.log("totalCostPerProd: ", totalCostPerProd);
  // console.log("dateTo: ", dateTo);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  return (
    <Drawer
      title="Transaction Report for Non-Cash & Cash"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {data.ready && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingRight: 15,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Date From: {moment(dateFrom).format("LLL")}
                {/* {moment(new Date(dateFrom)).format("MMMM DD, YYYY 00:00:00")} */}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 10,
                }}
              >
                Date To: {moment(dateTo).format("LLL")}
                {/* {moment(new Date(dateTo)).format("MMMM DD, YYYY 23:59:00")} */}
              </Typography>
              <Divider />
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Transaction
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                }}
              >
                Dine-In:{" "}
                {parseFloat(totalDineIn).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  // marginBottom: 10,
                }}
              >
                Take-Out:{" "}
                {parseFloat(totalTakeOut).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  // marginBottom: 10,
                }}
              >
                Pick Up:{" "}
                {parseFloat(totalPickup).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                Delivery:{" "}
                {parseFloat(totalDelivery).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Senders
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                }}
              >
                Cash:{" "}
                {parseFloat(totalCash).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  // marginBottom: 10,
                }}
              >
                E-Cash:{" "}
                {parseFloat(totalECash).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                GCash:{" "}
                {parseFloat(totalGCash).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                GCredit:{" "}
                {parseFloat(totalGCredit).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                Paymaya:{" "}
                {parseFloat(totalPaymaya).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                Credit Card:{" "}
                {parseFloat(totalCreditCard).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                Debit Card:{" "}
                {parseFloat(totalDebitCard).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                Bank Transfer:{" "}
                {parseFloat(totalBankTransfer).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 30,
                  // marginBottom: 10,
                }}
              >
                Cheque:{" "}
                {parseFloat(totalCheque).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 10,
                }}
              >
                Customer Count: {data.data.length}
              </Typography>
              <Divider style={{ margin: 0 }} />

              {perproductcost !== null && (
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 14,
                  }}
                >
                  {perproductcost.description}:{" "}
                  {parseFloat(totalCostPerProd).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              )}

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Discount:{" "}
                {parseFloat(totalDiscount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Total:{" "}
                {parseFloat(totalGross).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 10 }}>
            <div style={{ flexGrow: 1 }} />
            <div>
              <Button
                type="primary"
                onClick={handlePrint}
                icon={<PrinterOutlined />}
              >
                Print
              </Button>
            </div>
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantReading;
